module.exports = __webpack_public_path__ + "static/google-ads-6601d351f7f8ff851c1e7e5623ac0a2a.svg";